import Component from "../abstracts/Component";
import MEDIA_BREAKPOINTS from '../utils/mediaBreakpoints';

export default class SimpleCarouselComponent extends Component {

  get COMPONENTNAME() {
    return 'SimpleCarouselComponent';
  }

  get SELECTORS() {
    return {
      main: '[data-carousel="true"]:not(.slick-initialized)',
      prevArrow: '[data-prev-arrow]',
      nextArrow: '[data-next-arrow]',
      navDots: '[data-nav-dots]',
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
  }

  render() {
    super.render();
    this.dom = this.readDOM();

    if (!this.dom.main || !this.matchBreakpoints()) return;

    this.importLibrary().then(() => {
      this.initCarousel();
    });
  }

  mediaMatch(interval) {
    const [minpx, maxpx] = interval;
    return window.matchMedia(`screen and (min-width: ${minpx}px) and (max-width: ${maxpx}px)`).matches;
  }

  matchBreakpoints() {
    const bps = (this.$component.dataset.activeBreakpoint || '')
      .split(',')
      .map(bp => bp.trim())
      .filter(bp => bp);

    if (!bps.length) return true;

    return bps.reduce((acc, bp) => {
      return acc || this.mediaMatch(MEDIA_BREAKPOINTS[bp]);
    }, false);
  }

  importLibrary() {
    return new Promise((resolve, reject) => {
      this.moduleLoader.loadCarouselAndExecute(
        module => { resolve(module) },
        error => { reject(error) }
      );
    })
  }

  readDOM() {
    return {
      main: this.$component.querySelector(this.SELECTORS.main),
      prevArrow: this.$component.querySelector(this.SELECTORS.prevArrow),
      nextArrow: this.$component.querySelector(this.SELECTORS.nextArrow),
      navDots: this.$component.querySelector(this.SELECTORS.navDots),
    }
  }

  initCarousel() {
    const $main = $(this.dom.main);
    const toBoolean = (str, def) => str !== undefined ? str === 'true' : def;
    const toNumber = (str, def) => str !== undefined ? Number(str) : def;

    // responsive json
    let responsive = [];
    // breakpoints settings to add only if active
    // SM
    if (typeof this.dom.main.dataset.carouselSm !== 'undefined' ) {
      const breakpointSMSettings = {
        slidesToShow: toNumber(this.dom.main.dataset.slidesToShowSm, 1),
        dots: toBoolean(this.dom.main.dataset.dotsSm, true),
        arrows: toBoolean(this.dom.main.dataset.arrowsSm, true),
        centerMode: toBoolean(this.dom.main.dataset.centerModeSm, false),
        centerPadding: this.dom.main.dataset.centerPaddingSm,
        infinite: toBoolean(this.dom.main.dataset.infiniteSm, true),
        swipeToSlide: toBoolean(this.dom.main.dataset.swipeToSlideSm, false)
      };
      const breakpointSM = {
        breakpoint: (this.dom.main.dataset.carouselSm !== '')  ? parseInt(this.dom.main.dataset.carouselSm,10) : 375,
        settings: (toBoolean(this.dom.main.dataset.carouselSmDisable, false) ? "unslick" : breakpointSMSettings)
      };
      responsive.push(breakpointSM);
    }
    // MD
    if (typeof this.dom.main.dataset.carouselMd !== 'undefined' ) {
      let breakpointMDSettings = {
        slidesToShow: toNumber(this.dom.main.dataset.slidesToShowMd, 1),
        dots: toBoolean(this.dom.main.dataset.dotsMd, true),
        arrows: toBoolean(this.dom.main.dataset.arrowsMd, true),
        centerMode: toBoolean(this.dom.main.dataset.centerModeMd, false),
        centerPadding: this.dom.main.dataset.centerPaddingMd,
        infinite: toBoolean(this.dom.main.dataset.infiniteMd, true),
        swipeToSlide: toBoolean(this.dom.main.dataset.swipeToSlideMd, false)
      };
      let breakpointMD = {
        breakpoint: (this.dom.main.dataset.carouselMd !== '')  ? parseInt(this.dom.main.dataset.carouselMd,10) : 768,
        settings: (toBoolean(this.dom.main.dataset.carouselMdDisable, false) ? "unslick" : breakpointMDSettings)
      };
      responsive.push(breakpointMD);
    }
    // LG
    if (typeof this.dom.main.dataset.carouselLg !== 'undefined' ) {
      const breakpointLGSettings = {
        slidesToShow: toNumber(this.dom.main.dataset.slidesToShowLg, 1),
        dots: toBoolean(this.dom.main.dataset.dotsLg, true),
        arrows: toBoolean(this.dom.main.dataset.arrowsLg, true),
        centerMode: toBoolean(this.dom.main.dataset.centerModeLg, false),
        centerPadding: this.dom.main.dataset.centerPaddingLg,
        infinite: toBoolean(this.dom.main.dataset.infiniteLg, true),
        swipeToSlide: toBoolean(this.dom.main.dataset.swipeToSlideLg, false)
      };
      const breakpointLG = {
        breakpoint: (this.dom.main.dataset.carouselLg !== '')  ? parseInt(this.dom.main.dataset.carouselLg,10) : 992,
        settings: (toBoolean(this.dom.main.dataset.carouselLgDisable, false) ? "unslick" : breakpointLGSettings)
      };
      responsive.push(breakpointLG);
    }
    // all options
    let opts = {
      dots: toBoolean(this.dom.main.dataset.dots, true),
      fade: toBoolean(this.dom.main.dataset.fade, false),
      centerMode: toBoolean(this.dom.main.dataset.centerMode, false),
      arrows: toBoolean(this.dom.main.dataset.arrows, true),
      autoplay: toBoolean(this.dom.main.dataset.autoplay, true),
      infinite: toBoolean(this.dom.main.dataset.infinite, true),
      autoplaySpeed: toNumber(this.dom.main.dataset.autoplaySpeed, 3000),
      slidesToShow: toNumber(this.dom.main.dataset.slidesToShow, 1),
      slidesToScroll: toNumber(this.dom.main.dataset.slidesToScroll, 1),
      prevArrow: this.dom.prevArrow,
      nextArrow: this.dom.nextArrow,
      appendDots: this.dom.navDots ? this.dom.navDots : this.dom.main,
      variableWidth: toBoolean(this.dom.main.dataset.variableWidth, false),
      swipeToSlide: toBoolean(this.dom.main.dataset.swipeToSlide, false),
      responsive: responsive
    }

    if (typeof this.dom.main.dataset.centerPadding !== 'undefined' ) opts.centerPadding = this.dom.main.dataset.centerPadding;

    $main.on('init', (e, slick) => {
      this.emit(this.$customEvents.SIMPLE_CAROUSEL.init, {originalEvent: e, slick});
    });

    $main.on('beforeChange', (e, slick, curr, next) => {
      this.emit(this.$customEvents.SIMPLE_CAROUSEL.beforeChange, {originalEvent: e, slick, curr, next});
    });
    console.log('[SimpleCarouselComponent]',opts);
    $main.slick(opts);
  }

  initAsynchCarousel() {
    this.dom = this.readDOM();
    this.importLibrary().then(() => {
      this.initCarousel();
    });
  }
}
